import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppHeaderComponent } from './shared/app-header.component';
import { AppSidebarComponent } from './shared/app-sidebar.component';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppService } from './shared/services/app.service';
import { TranslationService } from './shared/services/translation.service';
import { NotificationService } from './shared/services/notification.service';

export interface BreadcrumbItem {
  label: string;
  url: string;
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, AppHeaderComponent, AppSidebarComponent, CommonModule, MatSidenavModule, TranslateModule, MatSnackBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'frontend';
  isLoginPage = false;
  breadcrumbs: BreadcrumbItem[] = [];

  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  public app = inject(AppService);
  private translation = inject(TranslationService);
  private notification = inject(NotificationService);

  ngOnInit() {
    // Sprawdzaj zmianę trasy i aktualizuj isLoginPage
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = this.checkIfLoginPage(event.url);
        this.updateBreadcrumbs(event.urlAfterRedirects);
        this.app.toggleSidenav(false)
        this.cdr.detectChanges();
      }
    });

    // Sprawdź aktualną trasę przy inicjalizacji
    this.isLoginPage = this.checkIfLoginPage(this.router.url);
    this.updateBreadcrumbs(this.router.url);
    this.cdr.detectChanges();

    // small demo message so snack-bar dependency is exercised globally
    if (!this.isLoginPage) {
      this.notification.success('Witaj w panelu administracyjnym');
    }
  }

  private checkIfLoginPage(url: string): boolean {
    // Usuń parametry query i sprawdź tylko ścieżkę
    const path = url.split('?')[0];
    return path === '/login' || path === '/' || path.startsWith('/login/');
  }


  updateBreadcrumbs(url: string) {
    console.log(url)
  }

}
